import React, { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { useFetch } from 'hooks';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';
import Spinner from 'ui/Spinner';
import { hasFeatureFlags } from 'utils/features';
import IsIframedInSeismic from 'ui/IsIframedInSeismic';

const PasswordChange = () => {
  const [hasCurrentPassword, setHasCurrentPassword] = useState(undefined);
  const [oldPassword, setOldPassword] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [passwordErrors, setPasswordErrors] = useState();
  const { data, loading, error } = useFetch(routes.SETTINGS.MY_ACCOUNT);

  useEffect(() => {
    if (data) {
      setHasCurrentPassword(data.hasCurrentPassword);
    }
  }, [loading, data, error]);

  const onSubmitPasswordChange = async () => {
    const result = await request.patchJSON(routes.SETTINGS.CHANGE_PASSWORD, {
      old_password: oldPassword,
      password,
      password_confirmation: passwordConfirmation,
    });
    if (result.success) {
      window.location.assign(routes.SIGNOUT);
    } else {
      setPasswordErrors(result.errors.flat());
      setOldPassword('');
      setPassword('');
      setPasswordConfirmation('');
    }
  };

  const hasUnificationFeatureFlag = hasFeatureFlags([
    'readiness-enable-unification',
  ]);

  return (
    <IsIframedInSeismic show={false}>
      {loading ? (
        <Spinner />
      ) : (
        <>
          {hasUnificationFeatureFlag || hasFeatureFlags(['central_auth']) ? (
            <div />
          ) : (
            <>
              <div className="Wrapper--thin" id="password-change">
                <h3 className="SettingsContent-heading">
                  {hasCurrentPassword
                    ? t('settings.tab.my_account.password_change.title')
                    : t('settings.tab.my_account.create_password.title')}
                </h3>
              </div>

              <hr />

              <div className="Wrapper--thin">
                {data.hidePasswordLogin ? (
                  <p id="sso-reset-help">{data.hidePasswordLoginText}</p>
                ) : (
                  <>
                    <form
                      onSubmit={e => {
                        e.preventDefault();
                        onSubmitPasswordChange();
                      }}
                    >
                      <div>
                        {!isEmpty(passwordErrors) &&
                          passwordErrors.map((err, index) => (
                            <p
                              className="HelpText error"
                              /* eslint react/no-array-index-key:0 */
                              key={`password_confirmation-${index}`}
                            >
                              {err}
                            </p>
                          ))}
                      </div>

                      <div className="controls">
                        {hasCurrentPassword && (
                          <>
                            <div>
                              <label htmlFor="old-password">
                                {t('common.current_password')}
                              </label>
                            </div>

                            <div>
                              <input
                                id="old-password"
                                type="password"
                                name="old-password"
                                className="form-control"
                                value={oldPassword}
                                onChange={e => setOldPassword(e.target.value)}
                                required
                              />
                            </div>

                            <br />
                          </>
                        )}

                        <div>
                          <label htmlFor="password">
                            {t('common.new_password')}
                          </label>
                        </div>

                        <div>
                          <input
                            id="password"
                            type="password"
                            name="password"
                            className="form-control"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            required
                          />
                        </div>
                        {hasFeatureFlags(['usernames']) ? (
                          <p
                            className="HelpText HelpText--muted HelpText--noBottomMargin"
                            dangerouslySetInnerHTML={{
                              __html: t(
                                'common.usernames_password_requirements_html',
                              ),
                            }}
                          />
                        ) : (
                          <p
                            className="HelpText HelpText--muted HelpText--noBottomMargin"
                            dangerouslySetInnerHTML={{
                              __html: t('common.password_requirements_html'),
                            }}
                          />
                        )}
                        <br />

                        <div>
                          <label htmlFor="password_confirmation">
                            {t('common.password_confirmation')}
                          </label>
                        </div>

                        <div>
                          <input
                            id="password-confirmation"
                            type="password"
                            name="password-confirmation"
                            className="form-control"
                            aria-label="password confirmation"
                            value={passwordConfirmation}
                            onChange={e =>
                              setPasswordConfirmation(e.target.value)
                            }
                            required
                          />
                        </div>

                        <br />

                        <div className="controls">
                          {t(
                            'settings.tab.my_account.password_change.will_log_you_out',
                          )}
                        </div>
                        <div className="d-f">
                          <button
                            id="submit-password"
                            type="submit"
                            className="ChangePasswordButton NewButton"
                          >
                            {hasCurrentPassword
                              ? t('common.password_submit')
                              : t(
                                  'settings.tab.my_account.create_password.set_password',
                                )}
                          </button>
                        </div>
                      </div>
                    </form>
                  </>
                )}
              </div>
            </>
          )}
        </>
      )}
    </IsIframedInSeismic>
  );
};

export default PasswordChange;
